import { CaretRightOutlined } from '@ant-design/icons';
import { Collapse, CollapseProps, Form, Grid, Switch, theme } from 'antd';
import { Modal } from 'components';
import { useGetSubCategoryCotmizeList } from 'features/new-clients/use-cases/sub-category-access';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { useState } from 'react';
import { CSSProperties } from 'styled-components';

const { useBreakpoint } = Grid;

export const AddCoustmizeModal = ({
  onClose,
  setSubCategoryPayload,
}: {
  onClose: () => void;
  setSubCategoryPayload: any;
}) => {
  const formName = 'add-category-form';
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<any>();
  const { data } = useGetSubCategoryCotmizeList('' as any);
  const { token } = theme.useToken();

  // State to track checked subcategories
  const [subCategoryChecks, setSubCategoryChecks] = useState<
    Record<string, boolean>
  >({});

  const handleSwitchChange = (checked: boolean, subCategoryId: string) => {
    setSubCategoryChecks((prev) => ({
      ...prev,
      [subCategoryId]: checked, // Update the checked status for this subcategory
    }));
  };

  const panelStyle: CSSProperties = { backgroundColor: '#f0f0f0' };

  const getItems: (panelStyle1: CSSProperties) => CollapseProps['items'] = (
    panelStyle1,
  ) =>
    data?.rc.map((category: any) => ({
      key: String(category.Id), // Use the CategoryId as the key
      label: category?.CategoryName, // Set the category name as the label
      children: (
        <div>
          {category.SubCategoryList.map((subCategory: any) => (
            <div
              key={subCategory.Id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px', // Add margin between subcategories
              }}
            >
              <span>{subCategory.SubCategory}</span> {/* Subcategory Name */}
              <Switch
                checked={subCategoryChecks[subCategory.Id]} // Use state for checked
                onChange={(checked) =>
                  handleSwitchChange(checked, subCategory.Id)
                } // Update state on toggle
                style={{ marginLeft: '16px' }} // Add space between subcategory name and switch
              />
            </div>
          ))}
        </div>
      ),
      style: panelStyle1,
    }));

  const handleUpdate = () => {
    // Create the payload with only the keys (ServiceId:{subCategoryId})
    const payload = Object.keys(subCategoryChecks)
      .filter((key) => subCategoryChecks[key]) // Only include checked subcategories
      .map((key) => ({ ServiceId: Number(key) })); // Create objects with ServiceId as key and its value
    setSubCategoryPayload(payload);
    // Log the payload or send to the API
    onClose();
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        title={'Select Sub-Categories'}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={'Save'}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
        }}
      >
        <Form
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          initialValues={{}}
          onFinish={handleUpdate}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
        >
          <Collapse
            bordered={false}
            defaultActiveKey={[]}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            style={{ background: token.colorBgContainer }}
            items={getItems(panelStyle)}
          />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
